{
  "label": "label",
  "name": "nom",
  "gamme": "gamme",
  "serialNumber": "Numéro de série",
  "firmwareVersion": "Version logicielle",
  "status": "Statut",
  "sector": "Secteur",
  "certificate": "Certificat",
  "connectivity": "Connectivité",
  "applicationDate": "Application date",
  "date": "Date",
  "startDate": "Date de début",
  "endDate": "Date de fin",
  "id": "Id",
  "search": "Recherche"
}
